import { ref } from 'vue'

// Singleton state so TopBarMobile and posts-container share the same drawer visibility
const isOpen = ref(false)

/**
 * Global state for the lesson navigator drawer (mobile course lesson page).
 * Used by TopBarMobile (button click) to open, and by posts-container
 * to render the drawer and bind v-model:show.
 */
export const useLessonNavigatorDrawer = () => {
  const setShow = (value: boolean) => {
    isOpen.value = value
  }
  const open = () => {
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
  }
  const toggle = () => {
    isOpen.value = !isOpen.value
  }
  return {
    isOpen,
    setShow,
    open,
    close,
    toggle,
  }
}
